import { render, staticRenderFns } from "./Alternativas.vue?vue&type=template&id=ea9effd4&"
import script from "./Alternativas.vue?vue&type=script&lang=js&"
export * from "./Alternativas.vue?vue&type=script&lang=js&"
import style0 from "./Alternativas.vue?vue&type=style&index=0&id=ea9effd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports